import React from "react";
// custom typefaces
import "typeface-montserrat";
import "typeface-merriweather";
// normalize CSS across browsers
import "./src/normalize.css";
// custom CSS styles
import "./src/style.css";
import Layout from "./src/components/layout";

// Highlighting for code blocks
// import "prism-themes/themes/prism-vsc-dark-plus.css";
import "prism-themes/themes/prism-night-owl.css";

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}